import { Appointment } from '@weave/schema-gen-ts/dist/schemas/schedule/calendar-events/v1/calendar_events.pb';
import { SchedulerV3 } from '@frontend/api-schedule-v3';
import { useCalendarEventsFormTypeShallowStore } from '@frontend/schedule-helpers';
import { CalendarEventsEnums } from '../../types';
import { NewAppointmentFormContainerV2 } from './NewAppointmentFormContainerV2';
import { NewAppointmentFormContainerV3 } from './NewAppointmentFormContainerV3';
import { OutOfOfficeEventFormContainerV2 } from './OutofOfficeEventFormContainerV2';
import { OutOfOfficeEventFormContainerV3 } from './OutofOfficeEventFormContainerV3';

type Props = {
  closeModal: () => void;
  onAppointmentSuccess?: (appointment?: Appointment) => void;
};

export const CalendarEventsModalContent = ({ closeModal, onAppointmentSuccess }: Props) => {
  const { isScheduleV3FlagEnabled } = SchedulerV3.Helpers.useGetSchedulerV3FeatureFlagDetails();

  const { selectedForm, setSelectedForm, setSelectedPerson } = useCalendarEventsFormTypeShallowStore(
    'selectedForm',
    'setSelectedForm',
    'setSelectedPerson'
  );
  const isNewAppointmentEvent = selectedForm === CalendarEventsEnums.APPOINTMENT_EVENT;

  const handleCloseModal = () => {
    setSelectedForm('');
    setSelectedPerson(null);
    closeModal();
  };

  if (isNewAppointmentEvent) {
    return isScheduleV3FlagEnabled ? (
      <NewAppointmentFormContainerV3 closeModal={handleCloseModal} onAppointmentSuccess={onAppointmentSuccess} />
    ) : (
      <NewAppointmentFormContainerV2 closeModal={handleCloseModal} onAppointmentSuccess={onAppointmentSuccess} />
    );
  }

  if (selectedForm) {
    return isScheduleV3FlagEnabled ? (
      <OutOfOfficeEventFormContainerV3 closeModal={handleCloseModal} eventType={selectedForm} />
    ) : (
      <OutOfOfficeEventFormContainerV2 closeModal={handleCloseModal} eventType={selectedForm} />
    );
  }

  return null;
};
